import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ImageComponent } from '@libs/common/components';
import { MediaContentModel } from '@libs/cms/models';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-media-content',
  templateUrl: './media-content.component.html',
  styleUrls: ['./media-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImageComponent,
  ],
})

export class MediaContentComponent extends ContentBaseComponent<MediaContentModel> {
}
